import {
  AUTHENTICATION_SWITCH_SIGNIN_PROCESS,
  AUTHENTICATION_USER_SIGNIN,
  AUTHENTICATION_USER_SIGNOUT,
  AUTHENTICATION_USER_UPDATEDATA,
} from "../lib/types";

const initialState = {
  user: null,
  idToken: null,
  accessToken: null,
  resourcesTokens: null,
  isSigningIn: false,
  isSigningOut: false,
  b2cData: null,
};

export default (state = initialState, action) => {
  /* discriminate the action type */
  switch (action.type) {
    case AUTHENTICATION_USER_SIGNIN:
      return {
        ...state,
        user: action.payload.user,
        idToken: action.payload.idToken,
        accessToken: action.payload.accessToken,
        resourcesTokens: action.payload.resourcesTokens,
        b2cData: action.payload.b2cData,
      };
    case AUTHENTICATION_SWITCH_SIGNIN_PROCESS:
      return {
        ...state,
        isSigningIn: action.payload,
      };
    case AUTHENTICATION_USER_SIGNOUT:
      return initialState;
    case AUTHENTICATION_USER_UPDATEDATA:
      return {
        ...state,
        user: {
          ...state.user,
          county: action.payload.county,
          mailingList: action.payload.mailingList,
          state: action.payload.state,
          jobTitle: action.payload.jobTitle,
          country: action.payload.country,
        },
        b2cData: action.payload.b2cData,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/authentication-reducer.js